module.exports = __webpack_public_path__ + "img/thantai-tangve.b0906bf3.png";